import styled from 'styled-components';

const SecondOption = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  
   @media only screen and (max-width: 1024px) {
    align-items: center;
  }
`;

export default SecondOption;
